import { Icon } from '@tag/tag-components-react-v2';
import { KnobValues } from '../Components/CodePreview/KnobsUtils';
export { IconList as Icons } from '@tag/tag-components-react-v2';

export type Page = {
  type: 'page';
  route: string;
  name: string;
  icon: Icon;
};

export type CoreComponent = {
  html?: string;
  knobs?: Knobs;
  knobInitialValues?: KnobValues;
  js?: string;
  events?: Event[];
  additionalEvents?: string[];
};

export type ReactWrapper = {
  jsx?: string;
  parentJSX?: string;
  knobs?: Knobs;
  knobInitalValues?: KnobValues;
  events?: Event[];
  additionalEvents?: string[];
};

export type Story = {
  title: string;
  description?: string;
  coreComponent?: CoreComponent;
  coreComponent_v3?: CoreComponent;
  reactWrapper?: ReactWrapper;
  reactWrapper_v3?: ReactWrapper;
};
export type Knob = {
  editor: 'textbox' | 'dropdown' | 'checkbox' | 'number' | 'multilinetextbox';
  editorOptions?: any[];
  default: any;
  attribute?: string;
  qualifierStart?: string;
  qualifierEnd?: string;
  delimiter?: string;
};
export type Knobs = { [key: string]: Knob };
export type Prop = {
  name: string;
  description: string;
  default?: string;
  type: string;
};
export type PropOverrides = {
  name: string;
  description?: string;
  default?: string;
  type?: string;
};
export type Event = {
  name: string;
  description: string;
  parameters: Prop[];
};
export type Method = {
  name: string;
  description: string;
  parameters: Prop[];
  returnType: string;
};
export type Component = {
  type: 'component';
  name: string;
  description: string;
  mobileFriendly: boolean;
  notForMobile?: boolean;
  preRelease: '' | 'alpha' | 'beta';
  popular: boolean;
  props: Prop[];
  reactPropOverrides: PropOverrides[];
  methods: Method[];
  events: Event[];
  stories: Story[];
  childComponents?: Component[];
};

export type SectionItem = Component | Page;

export type Section = {
  type: 'section';
  name: string;
  components: SectionItem[];
};

export type Doc = Page | Component | Section;

export const Accents = [
  'access',
  'atoll',
  'black',
  'coral',
  'denim',
  'dolphinblue',
  'finn',
  'flax',
  'gulfstream',
  'keppel',
  'midnightblue',
  'moon',
  'mojo',
  'navy',
  'plum',
  'shiraz',
  'sunflower',
  'surf',
  'tango',
  'title',
  'viridiangreen',
  'porcelain',
  'white',
];

export const MobileHeaderAccent = [
  'white',
  'access',
  'atoll',
  'denim',
  'plum',
  'keppel',
  'dolphinblue',
  'tango',
];

export const IconAccents = [
  'title',
  'coral',
  'sunflower',
  'access',
  'atoll',
  'dolphinblue',
  'finn',
  'flax',
  'keppel',
  'midnightblue',
  'mojo',
  'tango',
  'navy',
  'plum',
  'shiraz',
  'viridiangreen',
  'white',
  'porcelain',
];

export const TextTypes = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'feature',
  'kpi',
  'kpi-label',
  'small',
  'p',
  'span',
  'label',
  'default',
  'default-label',
  'edit-field-label',
  'min',
];

export const InputTypes = ['text', 'password', 'email', 'number'];
